var _path, _path2, _g, _path3, _path4, _path5, _g2, _g3, _g4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0596 3.7666C42.0815 1.44478 47.0367 1.44478 51.0586 3.7666L77.5244 19.0459C81.5466 21.3681 84.0244 25.6603 84.0244 30.3047V60.8633C84.0243 65.5075 81.5463 69.7989 77.5244 72.1211L51.0586 87.4004C47.0365 89.7224 42.0816 89.7224 38.0596 87.4004L11.5938 72.1211C7.57185 69.7989 5.0939 65.5075 5.09375 60.8633V30.3047C5.09375 25.6603 7.5716 21.3681 11.5938 19.0459L38.0596 3.7666Z",
    fill: "#F3F0FF",
    stroke: "#CFBFFF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2475_18000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 78,
    height: 87
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0591 3.76793C42.8437 2.16028 46.2744 2.16027 49.059 3.76792L78.524 20.7792C81.3086 22.3869 83.024 25.3581 83.024 28.5735V62.5959C83.024 65.8113 81.3086 68.7825 78.524 70.3902L49.059 87.4015C46.2744 89.0091 42.8437 89.0092 40.0591 87.4015L10.5942 70.3902C7.80952 68.7825 6.0941 65.8113 6.0941 62.5959V28.5735C6.0941 25.3581 7.80952 22.3869 10.5942 20.7793L40.0591 3.76793Z",
    fill: "#EDF2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2475_18000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2226 53.7924C16.2957 48.1421 19.1748 42.5507 24.3126 40.0232L41.1333 31.7482C42.1889 31.229 43.31 30.8554 44.466 30.6377L71.6253 25.523C78.4765 24.2328 85.1258 28.5767 86.6968 35.369L93.1227 63.1515C94.5221 69.2021 91.4465 75.3976 85.7809 77.9408L46.9186 95.3858C41.597 97.7747 35.3357 96.3263 31.6037 91.8432L23.7313 82.3865C22.2487 80.6055 21.2691 78.4605 20.8939 76.1736L17.2226 53.7924Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4207 81.6363C23.726 83.22 25.1792 84.3412 26.8394 84.4006C26.8488 84.3996 26.8582 84.3986 26.8678 84.3977C26.9201 84.393 26.9771 84.3899 27.038 84.3897L27.5518 84.3349L27.5625 84.3338L27.5732 84.3328L94.0343 78.0826L82.5673 18.6027L13.8236 31.8557L23.4207 81.6363ZM97.325 78.1121C97.5968 79.5222 96.4998 80.8744 94.9672 81.0183L27.8198 87.333L27.0497 87.4151L27.0237 87.4201L27.0036 87.4199L26.8997 87.4311L26.8476 87.419C23.6689 87.3986 20.8423 85.3012 20.2535 82.2469L10.5451 31.8895C10.2921 30.5771 11.2281 29.2927 12.6356 29.0213L82.6147 15.5302C84.0184 15.2596 85.3696 16.0994 85.6233 17.4153L97.325 78.1121Z",
    fill: "#CFBFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2475_18000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 78.4229L24.1424 94.0221L101.768 81.8354L31.7353 74.293C29.7241 82.0505 24.0738 80.2785 21.5 78.4229Z",
    fill: "#B197FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.3826 43.7966L86.9453 30.193L84.6689 18.3852L14.1062 31.9889L16.3826 43.7966ZM90.3053 30.1298C90.5368 31.3306 89.568 32.5268 88.1426 32.8016L16.2411 46.6634C14.8152 46.9383 13.4715 46.1878 13.24 44.9871L10.7463 32.0521C10.5148 30.8513 11.4831 29.6551 12.9091 29.3802L84.8105 15.5184C86.236 15.2436 87.5801 15.9939 87.8116 17.1948L90.3053 30.1298Z",
    fill: "#CFBFFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4616 4.64604L16.8231 1.81828L19.8333 4.66742L12.8736 7.68524L10.4616 4.64604Z",
    fill: "#7950F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4515 3.25716L67.0263 3.07633L66.0407 1.6869L61.0928 1.90836L62.4515 3.25716Z",
    fill: "#FFEC99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6127 5.66388L77.4 10.7567L78.2955 8.13213L75.5031 3.52744L74.6127 5.66388Z",
    fill: "#FFC9C9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2475_18000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.7549,
    y: 44.6766,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 23.7549 44.6766)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6537 42.3334C34.9266 42.5433 35.0067 42.9542 34.8326 43.2512L30.3747 50.8566C30.2006 51.1536 29.8382 51.2243 29.5653 51.0144L26.071 48.3277C25.7981 48.1178 25.718 47.7069 25.8921 47.4099C26.0661 47.1129 26.4285 47.0423 26.7014 47.2521L29.7016 49.5589L33.8443 42.4913C34.0184 42.1943 34.3807 42.1236 34.6537 42.3334Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5554 42.3205C33.8312 41.8505 34.4238 41.7348 34.8559 42.0669C35.2622 42.3793 35.3787 42.9762 35.1196 43.4183L30.6611 51.0241C30.3852 51.4942 29.7926 51.6099 29.3605 51.2777L25.8659 48.5912C25.4597 48.2787 25.3441 47.6817 25.6032 47.2396C25.8789 46.7693 26.4715 46.6537 26.9037 46.9861L29.6029 49.0609L33.5554 42.3205ZM34.4484 42.5968C34.3349 42.5097 34.2031 42.5349 34.1307 42.6584L29.9888 49.7264C29.9403 49.8089 29.8585 49.8669 29.7646 49.8853C29.6706 49.9036 29.5723 49.8809 29.4964 49.8225L26.4961 47.515C26.3826 47.4281 26.2518 47.454 26.1795 47.5774C26.0905 47.7292 26.1339 47.954 26.2734 48.0613L29.768 50.7478C29.8814 50.8349 30.0123 50.8095 30.0848 50.6863L34.5433 43.0805C34.632 42.9287 34.5878 42.7041 34.4484 42.5968Z",
    fill: "#F3F0FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2475_18000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.1944,
    y: 60.2216,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 26.1944 60.2216)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0921 57.8774C37.3651 58.0872 37.4452 58.4981 37.2711 58.7951L32.8132 66.4006C32.6391 66.6976 32.2767 66.7682 32.0038 66.5584L28.5095 63.8716C28.2366 63.6618 28.1564 63.2509 28.3305 62.9539C28.5046 62.6569 28.867 62.5862 29.1399 62.7961L32.1401 65.1029L36.2828 58.0352C36.4568 57.7382 36.8192 57.6675 37.0921 57.8774Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9948 57.8664C36.2706 57.3965 36.8633 57.2808 37.2954 57.6128C37.7017 57.9252 37.8181 58.5221 37.5591 58.9642L33.1005 66.57C32.8247 67.0402 32.2321 67.1558 31.7999 66.8236L28.3063 64.1369C27.9 63.8245 27.7835 63.2277 28.0426 62.7855C28.3184 62.3153 28.911 62.1997 29.3432 62.532L32.0425 64.6078L35.9948 57.8664ZM36.8879 58.1427C36.7744 58.0557 36.6436 58.0817 36.5713 58.2052L32.4282 65.2723C32.3798 65.3548 32.298 65.4128 32.2041 65.4312C32.1102 65.4495 32.0127 65.4265 31.9368 65.3683L28.9356 63.0609C28.8221 62.9741 28.6913 63 28.6189 63.1233C28.5299 63.2751 28.5734 63.4999 28.7128 63.6072L32.2076 66.2946C32.321 66.3814 32.4528 66.3553 32.5252 66.2321L36.9828 58.6264C37.0714 58.4746 37.0272 58.2499 36.8879 58.1427Z",
    fill: "#F3F0FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2475_18000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5733,
    y: 28.163,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 21.5733 28.163)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.472 25.8198C32.745 26.0296 32.8251 26.4405 32.651 26.7375L28.1931 34.3429C28.019 34.64 27.6566 34.7106 27.3837 34.5008L23.8894 31.814C23.6164 31.6042 23.5363 31.1933 23.7104 30.8963C23.8845 30.5993 24.2469 30.5286 24.5198 30.7384L27.5199 33.0452L31.6626 25.9776C31.8367 25.6806 32.1991 25.6099 32.472 25.8198Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3728 25.8078C31.6486 25.3379 32.2412 25.2222 32.6733 25.5542C33.0796 25.8666 33.196 26.4635 32.937 26.9057L28.4784 34.5114C28.2026 34.9816 27.61 35.0973 27.1779 34.765L23.6833 32.0785C23.2772 31.766 23.1615 31.169 23.4205 30.7269C23.6963 30.2568 24.2889 30.1411 24.7211 30.4734L27.4204 32.5492L31.3728 25.8078ZM32.2658 26.0841C32.1523 25.9971 32.0206 26.0232 31.9482 26.1467L27.8061 33.2137C27.7577 33.2962 27.6759 33.3542 27.582 33.3726C27.488 33.3909 27.3897 33.3682 27.3138 33.3098L24.3135 31.0023C24.2001 30.9155 24.0692 30.9415 23.9968 31.0647C23.9079 31.2165 23.9513 31.4413 24.0907 31.5486L27.5855 34.236C27.6989 34.3228 27.8298 34.2968 27.9021 34.1736L32.3608 26.5688C32.4498 26.417 32.4053 26.1914 32.2658 26.0841Z",
    fill: "#F3F0FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9707 29.9678C55.9707 28.1879 57.4135 26.7451 59.1934 26.7451H72.084C73.8638 26.7451 75.3066 28.1879 75.3066 29.9678C75.3066 31.7476 73.8638 33.1904 72.084 33.1904H62.416V39.6357H68.8613C70.5707 39.6357 72.2101 40.3148 73.4188 41.5235C74.6276 42.7322 75.3066 44.3716 75.3066 46.081V52.5263C75.3066 54.2358 74.6276 55.8751 73.4188 57.0839C72.2101 58.2926 70.5707 58.9717 68.8613 58.9717H62.416C60.7066 58.9717 59.0672 58.2926 57.8585 57.0839C56.6498 55.8751 55.9707 54.2358 55.9707 52.5263C55.9707 50.7465 57.4135 49.3037 59.1934 49.3037C60.9732 49.3037 62.416 50.7465 62.416 52.5263H68.8613V46.081H59.1934C57.4135 46.081 55.9707 44.6382 55.9707 42.8584V29.9678Z",
    fill: "#7950F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3967 26.9905C50.6009 27.4893 51.3861 28.6645 51.3861 29.9679V55.7498C51.3861 57.5296 49.9433 58.9725 48.1634 58.9725C46.3835 58.9725 44.9406 57.5296 44.9406 55.7498V37.7483L43.9967 38.6922C42.7381 39.9508 40.6976 39.9508 39.439 38.6922C38.1805 37.4337 38.1805 35.3931 39.439 34.1346L45.8846 27.6891C46.8063 26.7674 48.1924 26.4917 49.3967 26.9905Z",
    fill: "#212529"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3967 26.9905C50.6009 27.4893 51.3861 28.6645 51.3861 29.9679V55.7498C51.3861 57.5296 49.9433 58.9725 48.1634 58.9725C46.3835 58.9725 44.9406 57.5296 44.9406 55.7498V37.7483L43.9967 38.6922C42.7381 39.9508 40.6976 39.9508 39.439 38.6922C38.1805 37.4337 38.1805 35.3931 39.439 34.1346L45.8846 27.6891C46.8063 26.7674 48.1924 26.4917 49.3967 26.9905Z",
    fill: "#7950F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1685 18.433L54.5361 14.4534L56.5258 11.2695L63.689 15.6469L61.1685 18.433Z",
    fill: "#FFC9C9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.596 42.4071L81.3999 38.1098L83.2199 35.0291L88.8272 39.7495L86.596 42.4071Z",
    fill: "#99E9F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7791 22.4557L18.7858 19.6901L20.1494 17.7501L24.5539 18.3321L22.7791 22.4557Z",
    fill: "#99E9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.84494 36.8891L5.40418 32.3754L6.60661 34.775L1.63593 39.6309L0.84494 36.8891Z",
    fill: "#99E9F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3609 75.6141L15.4863 72.404L16.2661 74.0656L12.8595 77.5199L12.3609 75.6141Z",
    fill: "#7950F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6393 20.9078L69.5399 18.0131L70.9399 19.927L66.6806 23.0344L65.6393 20.9078Z",
    fill: "#7950F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6645 3.42241L31.9711 5.90744L33.0641 9.74312L27.2842 6.97622L26.6645 3.42241Z",
    fill: "#99E9F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 20.0366L27.6377 17.4132L26.3261 15.3145L21.6041 18.2L23.2656 20.0366Z",
    fill: "#FFEC99"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3588 3.10677L66.9335 2.92594L65.9479 1.53651L61.0001 1.75797L62.3588 3.10677Z",
    fill: "#FFEC99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6421 13.8176L66.8855 14.9175L67.7578 13.3099L64.2215 12.1451L63.6421 13.8176Z",
    fill: "#FFEC99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3651 75.1877L47.5154 76.791L48.9744 74.2301L43.3576 72.5361L42.3651 75.1877Z",
    fill: "#FFEC99"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5815 11.5572L16.2139 7.57759L15.0687 5.83398L8.48869 9.80112L9.5815 11.5572Z",
    fill: "#FFC9C9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5199 5.51251L77.3073 10.6053L78.2028 7.98077L75.4103 3.37608L74.5199 5.51251Z",
    fill: "#FFC9C9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7847 80.9183L80.7343 81.542L79.6709 79.4267L75.0221 79.0722L75.7847 80.9183Z",
    fill: "#FFC9C9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0659 36.1259L20.6982 33.5945L18.7085 31.5693L11.5454 34.3538L14.0659 36.1259Z",
    fill: "#FFC9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2475_18000",
    x: 7.9,
    y: 68.693,
    width: 93.8686,
    height: 30.9295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.677775 0 0 0 0 0.599488 0 0 0 0 0.903602 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_18000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_18000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2475_18000",
    x: 16.2744,
    y: 37.877,
    width: 19.9834,
    height: 20.0615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_18000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_18000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2475_18000",
    x: 18.7139,
    y: 53.4229,
    width: 19.9834,
    height: 20.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_18000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_18000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2475_18000",
    x: 14.0928,
    y: 21.3643,
    width: 19.9824,
    height: 20.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_18000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_18000",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.c615e42f2de32b900d208b7fc3bf3ced.svg";
export { ForwardRef as ReactComponent };